import { render, staticRenderFns } from "./nav-links.vue?vue&type=template&id=4ac515da&"
import script from "./nav-links.vue?vue&type=script&lang=js&"
export * from "./nav-links.vue?vue&type=script&lang=js&"
import style0 from "./nav-links.vue?vue&type=style&index=0&id=4ac515da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports